// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickCombobox_container__uMkrk {
  --foreground-color: var(--black);
  --background-color: var(--white);
  --border-radius: 0.25rem;
  --border-size: 2px;
  --focus-color: var(--blackAlpha);
  color: var(--foreground-color);
}
.ClickCombobox_container__uMkrk.ClickCombobox_dark__o102k {
  --foreground-color: var(--white);
  --background-color: var(--black);
  --focus-color: var(--whiteAlpha);
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l {
  display: inline-block;
  width: 100%;
  min-width: 100%;
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_textInput__KFNRX {
  font-size: 1em;
  border-radius: var(--border-radius);
  border: solid var(--border-size) var(--foreground-color);
  background: var(--white);
  color: var(--black);
  width: 100%;
  padding: 0.25em 0.5em;
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_textInput__KFNRX::placeholder {
  color: var(--gray);
  font-style: italic;
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_textInput__KFNRX:focus {
  outline: none;
  border-color: var(--blue);
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_listbox__NNgg3 {
  margin: 0;
  padding: 0;
  background: var(--white);
  color: var(--black);
  max-height: 10em;
  overflow-y: auto;
  margin-top: 0.25em;
  border-radius: var(--border-radius);
  border: var(--border-size) solid var(--blue);
  box-shadow: var(--box-shadow);
  z-index: 10;
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_listbox__NNgg3:not(.ClickCombobox_expanded__5sQZw) {
  display: none;
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_listbox__NNgg3:focus {
  outline: none;
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_listbox__NNgg3 > li {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0.25em 0.25em 0.25em 0.5em;
  cursor: pointer;
  white-space: nowrap;
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_listbox__NNgg3 > li.ClickCombobox_focus__2ZJ4v {
  background-color: var(--blue);
  color: var(--white);
}
.ClickCombobox_container__uMkrk .ClickCombobox_wrapper__gDB\\+l .ClickCombobox_listbox__NNgg3 > li:not(.ClickCombobox_focus__2ZJ4v):hover {
  background-color: var(--lightblue);
}
.ClickCombobox_container__uMkrk label {
  font-weight: var(--bold);
}
.ClickCombobox_container__uMkrk .ClickCombobox_helpText__\\+vJ-9 {
  display: block;
  font-size: 0.75em;
  padding-bottom: 0.25em;
}

.ClickCombobox_errorMessage__Qa04w {
  font-size: 0.75em;
  color: var(--danger);
  min-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/ClickCombobox.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,gCAAA;EACA,wBAAA;EACA,kBAAA;EACA,gCAAA;EAEA,8BAAA;AAAF;AACE;EACE,gCAAA;EACA,gCAAA;EACA,gCAAA;AACJ;AACE;EACE,qBAAA;EACA,WAAA;EACA,eAAA;AACJ;AAAI;EACE,cAAA;EACA,mCAAA;EACA,wDAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AAEN;AADM;EACE,kBAAA;EACA,kBAAA;AAGR;AADM;EACE,aAAA;EACA,yBAAA;AAGR;AAAI;EACE,SAAA;EACA,UAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,4CAAA;EACA,6BAAA;EACA,WAAA;AAEN;AADM;EACE,aAAA;AAGR;AAAM;EACE,aAAA;AAER;AACM;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mCAAA;EACA,eAAA;EACA,mBAAA;AACR;AAAQ;EACE,6BAAA;EACA,mBAAA;AAEV;AAAQ;EACE,kCAAA;AAEV;AAIE;EACE,wBAAA;AAFJ;AAIE;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;AAFJ;;AAKA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAFF","sourcesContent":[".container {\n  --foreground-color: var(--black);\n  --background-color: var(--white);\n  --border-radius: 0.25rem;\n  --border-size: 2px;\n  --focus-color: var(--blackAlpha);\n\n  color: var(--foreground-color);\n  &.dark {\n    --foreground-color: var(--white);\n    --background-color: var(--black);\n    --focus-color: var(--whiteAlpha);\n  }\n  .wrapper {\n    display: inline-block;\n    width: 100%;\n    min-width: 100%;\n    .textInput {\n      font-size: 1em;\n      border-radius: var(--border-radius);\n      border: solid var(--border-size) var(--foreground-color);\n      background: var(--white);\n      color: var(--black);\n      width: 100%;\n      padding: 0.25em 0.5em;\n      &::placeholder {\n        color: var(--gray);\n        font-style: italic;\n      }\n      &:focus {\n        outline: none;\n        border-color: var(--blue);\n      }\n    }\n    .listbox {\n      margin: 0;\n      padding: 0;\n      background: var(--white);\n      color: var(--black);\n      max-height: 10em;\n      overflow-y: auto;\n      margin-top: 0.25em;\n      border-radius: var(--border-radius);\n      border: var(--border-size) solid var(--blue);\n      box-shadow: var(--box-shadow);\n      z-index: 10;\n      &:not(.expanded) {\n        display: none;\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      > li {\n        position: relative;\n        display: flex;\n        justify-content: space-between;\n        padding: 0.25em 0.25em 0.25em 0.5em;\n        cursor: pointer;\n        white-space: nowrap;\n        &.focus {\n          background-color: var(--blue);\n          color: var(--white);\n        }\n        &:not(.focus):hover {\n          background-color: var(--lightblue);\n        }\n      }\n    }\n  }\n\n  label {\n    font-weight: var(--bold);\n  }\n  .helpText {\n    display: block;\n    font-size: 0.75em;\n    padding-bottom: 0.25em;\n  }\n}\n.errorMessage {\n  font-size: 0.75em;\n  color: var(--danger);\n  min-height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ClickCombobox_container__uMkrk`,
	"dark": `ClickCombobox_dark__o102k`,
	"wrapper": `ClickCombobox_wrapper__gDB+l`,
	"textInput": `ClickCombobox_textInput__KFNRX`,
	"listbox": `ClickCombobox_listbox__NNgg3`,
	"expanded": `ClickCombobox_expanded__5sQZw`,
	"focus": `ClickCombobox_focus__2ZJ4v`,
	"helpText": `ClickCombobox_helpText__+vJ-9`,
	"errorMessage": `ClickCombobox_errorMessage__Qa04w`
};
export default ___CSS_LOADER_EXPORT___;
